/* istanbul ignore file */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { SvgComponent } from './types';
// @ts-ignore
import Icon from './svgs/type-h3.tsx';

export const IconTypeH3 = Icon as SvgComponent;
